import { FormControl, MenuItem, Select } from '@mui/material'
import React from 'react'

export const CustomSelect = (props) => {
  const { name="",  value="", handleChange=null, label="", options=[] } = props
  return (
    <FormControl fullWidth>
    <label style={{color: '#fff', marginBottom: 12}}>{label}</label>
    <Select
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={value}
      onChange={handleChange}
      inputProps={{
        name: name
      }}
      sx={{backgroundColor: '#fff'}}
      >
      {
        options.map(opt => (
          <MenuItem key={opt.value} value={opt.value}>
            <p style={{
              textOverflow: 'ellipsis',
              overflow: 'hidden'
            }}>{ opt.label }</p>
          </MenuItem>
          ))
        }
    </Select>
  </FormControl>
  )
}
